// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Rating_wrapper__1NbF","info":"Rating_info__2ZRK","ratingWrapper":"Rating_ratingWrapper__5_6w","rating":"Rating_rating__2cuh","imgWrapper":"Rating_imgWrapper__2dxq","scores":"Rating_scores__1DUa","votes":"Rating_votes__1btt","vote":"Rating_vote__J70u","numVotes":"Rating_numVotes__1Ptw","comment":"Rating_comment__1eio","good":"Rating_good__2X0z","bad":"Rating_bad__2UHY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/util/Rating/Rating.scss
// module id = 1063
// module chunks = 0